"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
exports.take = operators_1.take;
//# sourceMappingURL=take.js.map